/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsChannelPriceResponseDto>
>;
export function request(
  params: API.tms.logisticsChannelPrice.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPrice/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
